var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shape",
      class: _vm.classInfo,
      on: {
        mouseenter: _vm.enter,
        mouseleave: _vm.leave,
        click: _vm.selectCurComponent,
        mousedown: _vm.handleMouseDownOnShape,
      },
    },
    [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isActive(),
            expression: "isActive()",
          },
        ],
        staticClass: "iconfont icon-xiangyouxuanzhuan",
        on: { mousedown: _vm.handleRotate },
      }),
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.element.isLock,
            expression: "element.isLock",
          },
        ],
        staticClass: "iconfont icon-suo",
      }),
      _vm._l(_vm.isActive() ? _vm.pointList : [], function (item) {
        return _c("div", {
          key: item,
          staticClass: "shape-point",
          style: _vm.getPointStyle(item),
          on: {
            mousedown: function ($event) {
              return _vm.handleMouseDownOnPoint(item, $event)
            },
          },
        })
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }